<div #triggerElemRef (click)="onTriggerClick(triggerElemRef)" class="cursor-pointer">
  <ng-content></ng-content>
</div>

<button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" class="hidden-button"></button>

<mat-menu
  #menu="matMenu"
  [xPosition]="menuXPosition"
  [yPosition]="menuYPosition"
  [overlapTrigger]="false"
  class="inline-user-chip"
>
  <ng-template matMenuContent>
    <mat-form-field appearance="outline" class="w-100">
      <div matPrefix class="d-flex ps-3">
        <div class="avatar-circle me-2">
          <span *ngIf="assignedUser && assignedUser !== unassignedUser; else showIcon">
            {{ assignedUser | nameInitials }}
          </span>
          <ng-template #showIcon>
            <mat-icon class="unassigned-icon s-icon">person</mat-icon>
          </ng-template>
        </div>
      </div>
      <input
        matInput
        [formControl]="searchControl"
        placeholder="{{ name || ('page.items.label.unassigned' | translate) }}"
        (click)="$event.stopPropagation()"
        (keydown)="$event.stopPropagation()"
      />
    </mat-form-field>
    <ng-container
      *ngIf="store.boardMembersLoading() === ELoadStatus.success || store.boardMembersLoading() === ELoadStatus.initial"
    >
      <ng-container *ngIf="store.boardMembers().length > 0; else noData">
        <ng-container *ngFor="let user of store.boardMembers()">
          <button mat-menu-item (click)="selectMenuItem(user)">
            <div class="d-flex align-items-center">
              <div class="avatar-circle me-2">
                <span *ngIf="user.name">{{ user.name | nameInitials }}</span>
                <span><mat-icon *ngIf="!user.name" class="unassigned-icon s-icon">person</mat-icon></span>
              </div>
              <div>
                <span class="fw-700 f-12">
                  {{ user.name ? (user.name | uppercase) : ('page.items.label.unassigned' | translate | uppercase) }}
                </span>
              </div>
            </div>
          </button>
        </ng-container>
      </ng-container>
      <ng-template #noData>
        <div class="no-data-item">
          {{ 'system.message.noDataAvailable' | translate }}
          <span (click)="goToUserSetting()" class="link"> -> {{ 'button.goToUserSettings' | translate }}</span>
        </div>
      </ng-template>
    </ng-container>
  </ng-template>
</mat-menu>
